import React, { useContext } from 'react'
import styled from 'styled-components'
import tasksContext from '~/contexts/tasks/tasksContext'
import colors from '~/styles/colors'
import { radius } from '~/styles/vars'

interface Props {
    id: string
}

const DeleteTaskButton: React.FC<Props> = ({ id }) => {
    const { dispatch } = useContext(tasksContext)

    const handleClick = (event: React.MouseEvent) => {
        event.stopPropagation()
        dispatch({ type: 'delete_task', data: { id } })
    }

    return (
        <Cross onClick={handleClick}>
            <Part1 />
            <Part2 />
        </Cross>
    )
}

const Cross = styled.div`
    cursor: pointer;
    width: 5rem;
    height: 5rem;
    position: relative;
    transition: 0.15s ease-in-out;
    :hover {
        transform: scale(0.9);
        transition: 0.15s ease-in-out;
    }
`

const CrossPart = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    width: 2.5rem;
    height: 0.5rem;
    background-color: ${colors.accent[500]};
    border-radius: ${radius.sm};
    transform-origin: 50% 50%;
`
const Part1 = styled(CrossPart)`
    transform: translate(-50%, -50%) rotate(45deg);
`
const Part2 = styled(CrossPart)`
    transform: translate(-50%, -50%) rotate(-45deg);
`

export default DeleteTaskButton
